import { createStandardAction } from 'typesafe-actions';

const PAGES_HISTORY_HOME_STORE_STATE = 'PAGES_HISTORY_HOME_STORE_STATE';
const PAGES_HISTORY_HOME_LOAD_STATE = 'PAGES_HISTORY_HOME_LOAD_STATE';
const PAGES_HISTORY_HOME_LOAD_STATE_ERROR = 'PAGES_HISTORY_HOME_LOAD_STATE_ERROR';

const PAGES_HISTORY_HOME_UPDATE_QUOTE_MESSAGE_ID = 'PAGES_HISTORY_HOME_UPDATE_QUOTE_MESSAGE_ID';
const PAGES_HISTORY_HOME_CHECK_QUOTE_LAST_SEEN_DATE = 'PAGES_HISTORY_HOME_CHECK_QUOTE_LAST_SEEN_DATE';
const PAGES_HISTORY_HOME_UPDATE_QUOTE_LAST_SEEN_DATE = 'PAGES_HISTORY_HOME_UPDATE_QUOTE_LAST_SEEN_DATE';

const PAGES_HISTORY_HOME_UPDATE_STATE_FROM_EXTERNAL_SOURCE = 'PAGES_HISTORY_HOME_UPDATE_STATE_FROM_EXTERNAL_SOURCE';

const PAGES_HISTORY_HOME_START_SAGA = 'PAGES_HISTORY_HOME_START_SAGA';
const PAGES_HISTORY_HOME_CANCEL_SAGA = 'PAGES_HISTORY_HOME_CANCEL_SAGA';

export const storePagesHistoryHomeState = createStandardAction(PAGES_HISTORY_HOME_STORE_STATE)();
export const loadPagesHistoryHomeState = createStandardAction(PAGES_HISTORY_HOME_LOAD_STATE)();
export const loadPagesHistoryHomeStateError = createStandardAction(PAGES_HISTORY_HOME_LOAD_STATE_ERROR)<any>();

export const updatePagesHistoryHomeQuoteMessageId = createStandardAction(PAGES_HISTORY_HOME_UPDATE_QUOTE_MESSAGE_ID)<
  any
>();
export const checkPagesHistoryHomeQuoteLastSeenDate = createStandardAction(
  PAGES_HISTORY_HOME_CHECK_QUOTE_LAST_SEEN_DATE,
)();
export const updatePagesHistoryHomeQuoteLastSeenDate = createStandardAction(
  PAGES_HISTORY_HOME_UPDATE_QUOTE_LAST_SEEN_DATE,
)<any>();

export const updatePagesHistoryHomeStateFromExternalSource = createStandardAction(
  PAGES_HISTORY_HOME_UPDATE_STATE_FROM_EXTERNAL_SOURCE,
)<any>();

export const startPagesHistoryHomeSaga = createStandardAction(PAGES_HISTORY_HOME_START_SAGA)();
export const cancelPagesHistoryHomeSaga = createStandardAction(PAGES_HISTORY_HOME_CANCEL_SAGA)();



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/actions.ts